(function(){
    'use strict';
    angular.module('app').controller('VehiclesController', VehiclesController);

    VehiclesController.$inject = ['$scope', 'FleetVehiclesTableService', '$location'];

    function VehiclesController($scope, FleetVehiclesTableService, $location) {

        const vm = this;

        init();

        function init() {
            const paginationData = {
                size: 5,
                page: 0,
                sort: 'id'
            };
            getVehicles(paginationData);

        }

        function getVehicles() {
            vm.vehiclesTableData = new FleetVehiclesTableService().tableData;
        }

    }
})();


// WEBPACK FOOTER //
// ./js/controllers/fleets/VehiclesController.js